import * as React from "react";
import { render } from "react-dom";
import "./shared/helpers/datadog/datadog";
import App from "./App";

render(<App />, document.getElementById("root"));
